import { render, staticRenderFns } from "./MealCategorySidebar.vue?vue&type=template&id=2fe87fa6&scoped=true"
import script from "./MealCategorySidebar.vue?vue&type=script&lang=js"
export * from "./MealCategorySidebar.vue?vue&type=script&lang=js"
import style0 from "./MealCategorySidebar.vue?vue&type=style&index=0&id=2fe87fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe87fa6",
  null
  
)

export default component.exports